<div class="modal-header" id="app-lock-modal-title">
    <h3 class="modal-title" id="modal-title">{{ model.titleText }}</h3>
</div>
<div class="modal-body" id="modal-body">
    <p [innerHTML]="model.bodyText"></p>
</div>
